import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
// import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import EventNoteIcon from "@mui/icons-material/EventNote";
import ForumIcon from "@mui/icons-material/Forum";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import CommentIcon from "@mui/icons-material/Comment";
import Zoom from "react-medium-image-zoom";
// import SubjectIcon from "@mui/icons-material/Subject";
import PollIcon from "@mui/icons-material/Poll";
// import PrograssBar from "./PrograssBar";
// import Radio from "@mui/material/Radio";
// import { Button, colors } from "@mui/material";
import { makePostRequest } from "../../../utils/utils";
import swal from "sweetalert";
import moment from "moment";
import { Grid } from "@mui/material";

// For Modal
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import RadioGroup from "@mui/material/RadioGroup";
// import Loader from "../../../assets/Images/loader.gif";
import avtarPic from "../../../assets/Images/avtarPic.png";
// End

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {/* <Typography>{children}</Typography> */}
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function NoticeBoardAndDiscuTab() {
  const navigate = useNavigate();

  const [value, setValue] = React.useState(0);
  const [noticeData, setNoticeData] = React.useState([]);
  const [q] = React.useState("");
  const MAX_LENGTH = 100;
  const [postList, setPostList] = React.useState([]);
  const [, setPollsList] = React.useState([]);
  const [pollObj, setPollObj] = React.useState({});
  // const [userObj, setUserObj] = React.useState({});
  const [showLoader, setShowLoader] = React.useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");

  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeNoticeBoard = () => {
    getAllNotice();
  };

  const handleChangeDiscussionForum = () => {
    getAllPosts();
  };

  const handleChangePolls = () => {
    GetAllpolls();
  };

  // const [sort, setSort] = React.useState("");

  // let resarr = [];
  async function getAllNotice() {
    setNoticeData([]);

    let bodyFormData = {
      searchq: q,
      status: "publish",
      pageNo: 1,
      count: 3,
      notice_visible_flag: "",
    };

    setShowLoader(true);
    await makePostRequest("commonapis/noticelisting", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data.data;
          if (data.length > 0) {
            setNoticeData(data);
            // detailsNotice(response.data.data.rows[0])
          } else setNoticeData([]);
        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  // async function getAllNotice() {
  //   setNoticeData([]);

  //   let bodyFormData = {
  //     searchq: q,
  //     // notice_visible_flag: "publish",
  //   };

  //   setShowLoader(true);
  //   await makePostRequest("commonapis/noticelisting/publish", bodyFormData)
  //     .then((response) => {
  //       if (response.status == "201") {
  //         const data = response.data.data.rows;
  //         if (data.length > 0) {
  //           setNoticeData(data);
  //           // detailsNotice(response.data.data.rows[0])
  //         } else setNoticeData([]);
  //       } else {
  //         swal("There was an error!", response.message, "warning");
  //       }
  //       setShowLoader(false);
  //     })
  //     .catch((err) => {
  //       swal("There was an error!", "more error details", "warning");
  //     });
  // }

  async function getAllPosts() {
    let inputData = {
      searchString: q,
      status: "newtoold",
      pageNo: 1,
      count: 3,
    };
    setShowLoader(true);
    makePostRequest("post/postListing", inputData)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data.data;
          if (data.length > 0) {
            // console.log("Post Listing ", data[0].json_agg);
            // if (data[0].json_agg) {
              setPostList(data);
            // } else {
            //   setPostList([]);
            // }
            setShowLoader(false);
          }else {
            setPostList([]);
            setShowLoader(false);
          }

        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function GetAllpolls() {
    setShowLoader(true);

    let bodyFormData = {
      searchq: q,
      sort: "newtoold",
      pageNo: 1,
      count: 5,
      status: "open",
    };
    await makePostRequest("polls/getAllPolls", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          setPollsList(response.data.data.data);
          if (response.data.data.data.length > 0) {
            setPollObj(response.data.data.data);
            // setUserObj(response.data.data[0].user_obj);
          } else {
            setPollObj({});
          }
        }
        setShowLoader(false);
      })
      .catch((err) => {
        console.log("Error ", err);
        let errMsg = err.response.data.message;

        swal(" " + errMsg, "", "warning", { timer: 2000, buttons: false });
        setShowLoader(false);
      });
  }

  const detailsNotice = async (keyinfo) => {
    localStorage.setItem("noticeInfodash", JSON.stringify(keyinfo));
    navigate("/NoticeBoardPage");
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    localStorage.removeItem("noticeInfodash");
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    getAllNotice();
    // getAllPosts();
    // GetAllpolls();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  // End

  return (
    <>
      <div>
        <div>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label="Notice board"
                  icon={<EventNoteIcon />}
                  {...a11yProps(0)}
                  onClick={handleChangeNoticeBoard}
                />
                <Tab
                  label="Discussion Forum"
                  icon={<ForumIcon />}
                  {...a11yProps(1)}
                  onClick={handleChangeDiscussionForum}
                />
                <Tab
                  label="Polls"
                  icon={<PollIcon />}
                  {...a11yProps(2)}
                  onClick={handleChangePolls}
                />
              </Tabs>
            </Box>
            {/* {(localStorage.getItem('showNoticeBoard')==true)? */}
            <TabPanel value={value} index={0}>
              <div className="noticeMain noticeNewMaster">
                <p
                  className="viewAllTe"
                  onClick={() => navigate("/NoticeBoardPage")}
                >
                  View All
                </p>
                {noticeData.length > 0 ? (
                  <>
                    {noticeData.map((key, index) => (
                      <div className="contInDiv" key={key.notice_id}>
                        <b
                          className="redMo"
                          onClick={() => detailsNotice(key)}
                        >
                          Read More <ArrowForwardIosIcon />
                        </b>
                        <h4>{key.notice_title}</h4>
                        <span>
                          {moment(key.created_at).format("DD-MM-YYYY")}{" "}
                          {moment(key.created_at).format("hh:mm A")}
                        </span>
                        <div className="notice-description"> 
                          {key.notice_description.length > MAX_LENGTH ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  key.notice_description.substring(
                                    0,
                                    MAX_LENGTH
                                  ) + "...",
                              }}
                            ></div>
                          ) : (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: key.notice_description,
                              }}
                            ></div>
                          )}
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <div className="noTickTx">No Notice Available....</div>
                )}
              </div>
            </TabPanel>
            {/* :<></>} */}

            {/* {(localStorage.getItem('showDiscussionForum')==true)? */}
            <TabPanel value={value} index={1}>
              <div className="discusMain">
                <p
                  className="viewAllTe"
                  onClick={() => navigate("/DiscussionForumPage")}
                >
                  View All
                </p>
                {postList.length > 0 ? (
                  <>
                    {postList.map(
                      (option, index) =>
                        index <= 2 && (
                          <>
                            <div
                              className="parkSocityInner"
                              key={option.post_id}
                            >
                              <div className="parkSocityTop">
                                <div className="parkSocityTopPro">
                                  {option.profile ? (
                                    <Zoom>
                                      <img src={option.profile} alt="altimg"/>
                                    </Zoom>
                                  ) : (
                                    <Zoom>
                                      <img alt="Remy Sharp" src={avtarPic} />
                                    </Zoom>
                                  )}
                                </div>
                                <h4>
                                  {option.fname} {option.lname}
                                </h4>
                                <div className="parkWi">
                                  <b>{option.contact_no}</b>
                                  <span>
                                    {moment(option.created_at).format(
                                      "DD-MM-YYYY"
                                    )}{" "}
                                    {moment(option.created_at).format(
                                      "hh:mm A"
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className="parContTxOuter">
                                <h5>{option.post_title}</h5>
                                <p className="parContTx">
                                  {option.description.length > MAX_LENGTH ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          option.description.substring(
                                            0,
                                            MAX_LENGTH
                                          ) + "...",
                                      }}
                                    ></div>
                                  ) : (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: option.description,
                                      }}
                                    ></div>
                                  )}
                                </p>
                              </div>

                              {/* <p className="discutionSmallContTx">
              Maecenas quam nunc, sagittis non condimentum at, rutrum sit amet
              eros. Fusce rutrum, lectus in blandit sagittis, mi tortor
              ullamcorper mi, vitae vestibulum libero quam a nisi. In eu mauris
              et neque sodales porta eu eget dui. Nunc eu quam sit amet justo
              elementum mollis. Orci varius natoque penatibus et magnis dis
              parturient montes, nascetur ridiculus mus. Sed laoreet metus
              nulla, in gravida urna rhoncus in.
            </p> */}
                              <div className="parkSocialOut">
                                <div>
                                  <ThumbUpIcon onClick={() => navigate("/DiscussionForumPage")}/>
                                  {option.likecount ? (
                                    <span>
                                      {option.likecount}{" "}
                                      {option.likecount === 1 ? (
                                        <> Like</>
                                      ) : (
                                        <>Likes</>
                                      )}
                                    </span>
                                  ) : (
                                    <span>0 Like</span>
                                  )}
                                </div>
                                <div>
                                  <CommentIcon onClick={() => navigate("/DiscussionForumPage")}/>
                                  {option.maincommentcount ? (
                                    <span>
                                      {option.maincommentcount} Comments
                                    </span>
                                  ) : (
                                    <span>0 Comments</span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )
                    )}
                  </>
                ) : (
                  <div className="Available">No Post Available....</div>
                )}
              </div>
            </TabPanel>
            {/* :<></>} */}

            {/* {(localStorage.getItem('showPolls')==true)? */}
            <TabPanel value={value} index={2}>
              <div className="pollTbMain">
                <p className="viewAllTe" onClick={() => navigate("/PollsPage")}>
                  View All
                </p>

                {pollObj.length > 0 ? (
                  <>
                    {pollObj.map(
                      (obj, index) =>
                        index <= 2 && (
                          <div className="parkSocityInner">
                            <div className="parkSocityTop">
                              <div className="parkSocityTopPro">
                                {pollObj.profile_pic ? (
                                  <Zoom>
                                    <img src={pollObj.profile_pic} alt="altimg"/>
                                  </Zoom>
                                ) : (
                                  <Zoom>
                                    <img alt="Remy Sharp" src={avtarPic} />
                                  </Zoom>
                                )}
                              </div>
                              <div className="pollConTopDiv">
                                <div>
                                  <h4>
                                    {obj.fname} {obj.lname}
                                  </h4>
                                  <div className="parkWi">
                                    <b>{obj.contact_no}</b>
                                  </div>
                                </div>

                                <div>
                                  <h4>Poll open time</h4>
                                  <div className="parkWi">
                                    <b>
                                      {" "}
                                      {moment(obj.poll_start_datetime).format(
                                        "DD-MM-YYYY h:mm:ss a"
                                      )}
                                    </b>
                                  </div>
                                </div>
                                <div>
                                  <h4>Poll close time</h4>
                                  <div className="parkWi">
                                    <b>
                                      {" "}
                                      {moment(obj.poll_expiry_datetime).format(
                                        "DD-MM-YYYY h:mm:ss a"
                                      )}
                                    </b>
                                  </div>
                                </div>
                                <div>
                                  <h4 className="votSt">Vote Now</h4>
                                  <div className="parkWi">
                                    <b className="closingSt">Closing soon</b>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="parContTxOuter">
                              <p className="parContTx">{obj.polltopic}</p>
                              <p className="discutionSmallContTx">
                                {obj.description}
                              </p>
                            </div>
                            {/* <div className="prograssMain myPollRadio">
                      <RadioGroup>
                        {obj.poll_option ? (
                          <>
                            {obj.poll_option.map((key) => (
                              <span className="progRadio" key={key}>
                                <FormControlLabel
                                  value={key}
                                  control={<Radio />}
                                  label={key}
                                />
                              </span>
                            ))}
                          </>
                        ) : (
                          <></>
                        )}
                      </RadioGroup>
                    </div> */}
                            {/* <div className="viewResul">
                      <Button onClick={handleClickOpen("body")}>
                        View Result
                      </Button>
                    </div> */}
                          </div>
                        )
                    )}
                  </>
                ) : (
                  <span>No Polls Created</span>
                )}
              </div>
            </TabPanel>
            {/* :<></>} */}
          </Box>
        </div>

        <div className="modalMain">
          {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
          <Dialog
            open={open}
            // onClose={handleClose}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            className="pollResulModMain"
          >
            <DialogTitle id="scroll-dialog-title" className="modalHeading">
              <span>Poll Result</span>
              <h4>Open Exit gate for vehicles</h4>
              <CloseIcon className="modalCloseBt" onClick={handleClose} />
            </DialogTitle>

            <DialogContent dividers={scroll === "paper"}>
              <div className="modalInnerCont">
                <div className="pollResultMain">
                  <div className="pollResultContDiv">
                    <h3 className="pollResultContTop">
                      <span>Open exit gate</span>
                      <b>24</b>
                    </h3>
                    <div className="pollResultInerContDiv">
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Savannah Nguyen</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://i.pinimg.com/474x/98/51/1e/98511ee98a1930b8938e42caf0904d2d.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Eleanor Pena</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSncmmqqEZ7dIwDpHmcdDZ3xHX-5NJNHFHsksqOmky_d4BmpUfgzmlK6z0InPcD6eFop6w&usqp=CAU" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Brooklyn Simmons</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://img.freepik.com/free-photo/half-profile-image-handsome-young-caucasian-man-with-good-skin-brown-eyes-black-stylish-hair-stubble-posing-isolated-against-blank-wall-looking-front-him-smiling_343059-4560.jpg?w=360" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Darlene Robertson</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnMTHPLoii3BsNcreEz-VSVp38etPGG4W2oDa98ckE16s-k6m1WOAC1sZPexttitJ8WGI&usqp=CAU" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Theresa Webb</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Devon Lane</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Jane Cooper</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Darrell Steward</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Cody Fisher</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Jenny Wilson</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Bessie Cooper</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Jerome Bell</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Savannah Nguyen</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Savannah Nguyen</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Savannah Nguyen</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Savannah Nguyen</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                  <div className="pollResultContDiv">
                    <h3 className="pollResultContTop">
                      <span>Continue with current arrangements</span>
                      <b>6</b>
                    </h3>
                    <div className="pollResultInerContDiv">
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Savannah Nguyen</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Savannah Nguyen</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Savannah Nguyen</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Savannah Nguyen</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Savannah Nguyen</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Savannah Nguyen</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="pollResultInerContpro">
                            <div className="pollResultProDi">
                              <Zoom>
                                <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                              </Zoom>
                            </div>
                            <h2>Savannah Nguyen</h2>
                            <span>Wing A - 951</span>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        </div>

        {/* {showLoader ? (
        <div className="loaderOut" id="loaderId">
          <div className="loaderBox">
            <img src={Loader} />
          </div>
        </div>
      ) : (
        <></>
      )} */}

        {showLoader ? (
          <div className="loaderOter" id="loaderId">
            <div className="wrapper">
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="shadow"></div>
              <div className="shadow"></div>
              <div className="shadow"></div>
              <span>Loading</span>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

export default NoticeBoardAndDiscuTab;
